import { L10n } from '../L10n/L10n';
import { IDataSourceBase } from '../models/IDataSourceInfo';
import { Module } from '../Module';
import { DataSources } from '../resources/Datasources';
import { IError } from '../ServerApi/types/IError';
import { RefreshModeTypes } from '../ServerApi/types/IRemoteRefreshProperties';
import { IResult } from '../ServerApi/types/IResponse';
import { ToasterService, ToastType } from './ToasterService';

export class ChangeDatasourceRemoteAgentAction {

  public static $inject = ['$translate', '$q', 'DataSources'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private $q: ng.IQService,
    private DataSources: DataSources) { }

  public execute(datasource: IDataSourceBase,
                 newRemoteAgentName: string,
                 currentRefreshMode: string,
                 suppressErrorToast: boolean,
                 workflowId?: string): ng.IPromise<IResult> {
    // If this no-op is changed, please check the logic for suppressSuccessToast at all call sites.
    if (currentRefreshMode !== RefreshModeTypes.Remote) {
      // no-op because the refresh mode isn't remote
      return this.$q.when({});
    }

    return this.DataSources.setRemoteAgent(datasource.id, newRemoteAgentName, workflowId).then((result: IResult) => {
      if (!suppressErrorToast && result.errors && result.errors.length) {
        ToasterService.instance.pop({ type: ToastType.Error, text: this.errorMessageFor(result.errors[0], datasource)});
      }

      if (!result.errors || !result.errors.length) {
        if (currentRefreshMode === RefreshModeTypes.Remote) {
          ToasterService.instance.pop({
            type: ToastType.Success,
            text: this.successMessageFor(newRemoteAgentName)
          });
        } else {
          ToasterService.instance.pop({ type: ToastType.Success, text: this.$translate.instant('editRemoteRefreshPropertiesServerSuccess')});
        }
      }

      return result;
    });

  }

  private errorMessageFor(error: IError, datasource: IDataSourceBase) {
    switch (error.code) {
      default:
        return this.$translate.instant('errorUnknown');
    }
  }

  public successMessageFor(newRemoteAgentName: string): string {
    return this.$translate.instant('editRemoteRefreshPropertiesAgentSuccess',
      {AGENT_NAME: L10n.elideIfLong(newRemoteAgentName)});
  }


}

Module.instance().service('ChangeDatasourceRemoteAgentAction', ChangeDatasourceRemoteAgentAction);
